import React from 'react'
import styled from '@emotion/styled'
import { MdKeyboardArrowRight } from 'react-icons/md'
import Link from 'src/components/Link'
import Image from 'src/components/Image'
import { typography, colors, globals, animations } from 'src/styles'
import { getSlugLink } from 'src/utils/format'

const CardTitle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 20px;
  overflow: hidden;
  .animated-arrow {
    color: ${ colors.mainColor };
    flex-shrink: 0;
    display: block;
    width: 24px;
    height: 24px;
    margin-right: -9px;
    position: relative;
    margin-left: 16px;
    svg {
      display: block;
      width: 100%;
      height: 100%;
      transition: transform ${ animations.mediumSpeed } ease-in-out, opacity ${ animations.mediumSpeed } ease-in-out;
      &:first-of-type {
        opacity: 0;
        position: absolute;
        top: 0;
        right: 50%;
      }
    }
  }
`

const Wrapper = styled(globals.Card)`
  text-align: left;
  display: block;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: ${ colors.white };
  .gatsby-image-wrapper,
  .gatsby-image-wrapper img {
    margin: 0;
    border-top-left-radius: ${ globals.cardBorderRadius };
    border-top-right-radius: ${ globals.cardBorderRadius };
  }
  p {
    ${ typography.articleTitleSmall }
    color: ${ colors.textColor };
    max-width: 34em;
    margin: 0;
  }
  &:hover {
    box-shadow: ${ globals.shadowLift };
    ${ CardTitle } {
      .animated-arrow {
        svg {
          transform: translate3d(50%, 0, 0);
          &:first-of-type {
            opacity: 1;
          }
          &:last-of-type {
            opacity: 0;
          }
        }
      }
    }
  }
`

const LinkCard = ({
  className,
  item,
  sizes
}) => {
  const actionType = item.link.type || 'pageLink'
  return (
    <Wrapper
      as={Link}
      to={actionType === 'externalLink' ? item.link.externalLink : getSlugLink(item.link.link, false, item.link.linkSection)}
      external={actionType === 'externalLink'}
      target={item.link.newTab ? '_blank' : ''}
      title={item.link.title}
      name={item.link.title}
      className={className}
    >
      {item?.image?.asset?.gatsbyImageData && (
        <Image
          isLinkCard={true}
          ratio={2 / 3}
          image={item?.image?.asset?.gatsbyImageData}
          alt={item?.image?.altText || item?.text?.eyebrow || item?.image?.originalFilename}
          sizes={sizes}
          format={['auto', 'avif', 'webp']}
        />
      )}
      <CardTitle>
        <p>{item.link.title}</p>
        <span className='animated-arrow'>
          <MdKeyboardArrowRight/>
          <MdKeyboardArrowRight/>
        </span>
      </CardTitle>
    </Wrapper>
  )
}

export default LinkCard
